var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#F12D40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6667 23.12H43.3333V19.72C43.3333 18.2198 42.1375 17 40.6667 17H27.3333C25.8625 17 24.6667 18.2198 24.6667 19.72V23.12H19.3333C18.5958 23.12 18 23.7277 18 24.48V25.84C18 26.027 18.15 26.18 18.3333 26.18H20.85L21.8792 48.4075C21.9458 49.8568 23.1208 51 24.5417 51H43.4583C44.8833 51 46.0542 49.861 46.1208 48.4075L47.15 26.18H49.6667C49.85 26.18 50 26.027 50 25.84V24.48C50 23.7277 49.4042 23.12 48.6667 23.12ZM40.3333 23.12H27.6667V20.06H40.3333V23.12Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.73e729c44e4a1a56ab869ba38270ae6a.svg";
export { ForwardRef as ReactComponent };